import {TipoUsuario} from "./TipoUsuario";

export class AutenticacaoToken {

    token?: string;
    usuarioUuid?: string;
    usuarioEmail?: string;
    tipo?: TipoUsuario;
    mensagem?: string;
    salvarSenha?: boolean;


    constructor(token?: string) {
        this.token = token;
    }
}